import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-100/40 via-background-50 to-accent-100/30"></div>
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/20 rounded-full blur-3xl -translate-y-1/4 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 text-xs font-medium text-primary-700 bg-primary-100 rounded-full mb-5">
              {heroData.tagline}
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-foreground-700 font-medium mb-4">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(heroData.primaryCta.href);
                }}
                className="px-8 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.text}
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(heroData.secondaryCta.href);
                }}
                className="px-8 py-3 text-sm font-semibold text-foreground-700 bg-background-100 hover:bg-background-200 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.text}
                <i className="ri-download-line ml-2"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20amber%20and%20coral%20gradients%2C%20floating%20film%20frames%20and%20movie%20elements%2C%20modern%20minimalist%20entertainment%20aesthetic%2C%20soft%20bokeh%20lighting%20effects%2C%20dark%20background%20with%20warm%20glowing%20highlights%2C%20elegant%20art%20deco%20inspired%20design%2C%20no%20text%20or%20faces&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                  alt="91影视看片app - 最新电影在线看、热门电视剧全集与综艺节目在线播放"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-accent-500/20 rounded-lg hidden lg:block"></div>
              <div className="absolute -top-4 -left-4 w-16 h-16 bg-primary-500/20 rounded-lg hidden lg:block"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}